import PropTypes from 'prop-types';
import React from 'react';
import NavDropdown from 'react-bootstrap/lib/NavDropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import SvgIcon from 'components/SvgIcon/SvgIcon';

const ActiveHireNavDropdown = ({
  messagesLink,
  id,
  endHire,
  canEndHire,
  makePayment,
  canMakePayment,
}) => {
  let endHireMenuItem = <div />;
  let makePaymentMenuItem = <div />;
  if (canEndHire) {
    endHireMenuItem = <MenuItem onClick={() => endHire()}>End hire</MenuItem>;
  }
  if (canMakePayment) {
    makePaymentMenuItem = (
      <MenuItem onClick={() => makePayment()}>Make payment</MenuItem>
    );
  }
  return (
    <div style={{ listStyleType: 'none' }}>
      <NavDropdown
        noCaret
        pullRight
        title={
          <span style={{ top: '3px' }}>
            <SvgIcon color="#333" size="24" icon="more" />
          </span>
        }
        style={{ color: 'white' }}
        id={id}
      >
        <MenuItem href={messagesLink}>Messages</MenuItem>
        {makePaymentMenuItem}
        <MenuItem href="/payments">Payment history</MenuItem>
        {endHireMenuItem}
      </NavDropdown>
    </div>
  );
};

ActiveHireNavDropdown.propTypes = {
  messagesLink: PropTypes.string,
  id: PropTypes.string,
  endHire: PropTypes.func,
  canEndHire: PropTypes.bool,
  makePayment: PropTypes.func,
  canMakePayment: PropTypes.bool,
};

ActiveHireNavDropdown.defaultProps = {
  messagesLink: '/messages',
  id: 'dropdown-icon',
};

export default ActiveHireNavDropdown;
